var partners_accordion = ( function ( $ ) {

	var $partners_accordion;

	var _init = function () {
		$partners_accordion = $( '#partners-accordion' );
		var $collapse_links = $partners_accordion.find( 'a.heading-link' );

		$collapse_links.first().attr( 'aria-expanded', 'true' );
	};

	if ( $( '#partners-accordion' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = partners_accordion;
